{
  "fr": {
    "question": {
      "actions": {
        "addDocuments": "Ajouter documents",
        "cancel": "Annuler",
        "createQuestion": "Nouvelle question",
        "delete": "Supprimer",
        "deleteDocuments": "Supprimer documents",
        "edit": "Modifier",
        "moveDown": "Déplacer vers le bas",
        "moveUp": "Déplacer vers le haut",
        "new": "Question",
        "save": "Enregistrer"
      },
      "attributes": {
        "answer": "Réponse",
        "documents": "Documents / Images",
        "name": "Question",
        "question": "Question"
      },
      "labels": {
        "editQuestion": "Modifier la question",
        "newQuestion": "Nouvelle question"
      },
      "toasts": {
        "create": "Question créée",
        "delete": "Question supprimée",
        "update": "Question modifiée"
      },
      "validation": {
        "needAnswer": "Réponse requise",
        "needQuestion": "Question requise"
      }
    }
  }
}